import Axios from 'axios';
import { API_URL } from '../../../constants/Constants';
import { ApiObjPopulateFile } from '../../object/populate_file/ApiObjPopulateFile';

export const api_populate_file_get_single = async (populateFileId: number) : Promise<ApiObjPopulateFile> => {
    
    const url = API_URL+'/populate_file/'+populateFileId;
    const config = {
        'Access-Control-Allow-Origin': API_URL,
        withCredentials: true 
    }
    
    const resp = await Axios.get(
        url,
        config
    );

    return new ApiObjPopulateFile(resp.data);
}
